<template>
  <div class="blog-post-card1-blog-post-card" v-bind:class="rootClassName">
    <div class="blog-post-card1-image1">
      <img :alt="imageAlt" :src="imageSrc1" class="blog-post-card1-image2" />
    </div>
    <div class="blog-post-card1-container1">
      <span class="blog-post-card1-text1">{{ label }}</span>
      <span class="blog-post-card1-text2">{{ title }}</span>
      <span class="blog-post-card1-text3">{{ description }}</span>
      <div class="blog-post-card1-container2">
        <div class="blog-post-card1-profile">
          <div class="blog-post-card1-container3"></div>
          <span class="blog-post-card1-text4">{{ author }}</span>
        </div>
        <span class="blog-post-card1-text5">{{ time }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlogPostCard1',
  props: {
    label: {
      type: String,
      default: 'NOUTATI',
    },
    imageAlt: {
      type: String,
      default: 'image',
    },
    imageSrc1: {
      type: String,
      default: '/news-1500w.webp',
    },
    description: {
      type: String,
      default: 'lOREM IPSUM LOREM IPSUM ....',
    },
    time: String,
    rootClassName: String,
    author: {
      type: String,
      default: 'Publicat:',
    },
    title: {
      type: String,
      default: 'Adunarea Generala Extraordinara a actionarilor',
    },
  },
}
</script>

<style scoped>
.blog-post-card1-blog-post-card {
  width: 100%;
  display: flex;
  overflow: hidden;
  max-width: var(--dl-size-size-maxwidth);
  box-shadow: 5px 5px 10px 0px rgba(18, 18, 18, 0.1);
  transition: 0.3s;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
 
.blog-post-card1-blog-post-card:hover {
  transform: scale(1.02);
}
 
.blog-post-card1-image1 {
  width: 100%;
  height: 250px;
  display: flex;
  align-items: center;
  background-size: cover;
  justify-content: center;
  background-image: url('https://play.teleporthq.io/static/svg/default-img.svg');
  background-position: center;
}
 
.blog-post-card1-image2 {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
 
.blog-post-card1-container1 {
  display: flex;
  padding: var(--dl-space-space-twounits);
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
}
 
.blog-post-card1-text1 {
  color: #595959;
  font-weight: 700;
  margin-bottom: var(--dl-space-space-halfunit);
  text-transform: uppercase;
}
 
.blog-post-card1-text2 {
  font-size: 1.5rem;
  font-weight: 300;
  margin-bottom: var(--dl-space-space-twounits);
}
 
.blog-post-card1-text3 {
  color: rgb(89, 89, 89);
  font-weight: 400;
  margin-bottom: var(--dl-space-space-twounits);
}
 
.blog-post-card1-container2 {
  width: 100%;
  display: flex;
  align-items: center;
  padding-top: var(--dl-space-space-unit);
  border-color: #D9D9D9;
  border-width: 1px;
  flex-direction: row;
  justify-content: space-between;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
}
 
.blog-post-card1-profile {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
}
 
.blog-post-card1-container3 {
  width: var(--dl-size-size-small);
  border: 2px dashed rgba(120, 120, 120, 0.4);
  height: var(--dl-size-size-small);
  display: flex;
  align-items: center;
  border-radius: var(--dl-radius-radius-round);
  background-size: cover;
  justify-content: center;
  background-image: url("/logoblue.svg");
  background-position: center;
}
 
.blog-post-card1-text4 {
  font-weight: 300;
  margin-left: var(--dl-space-space-halfunit);
}
 
.blog-post-card1-text5 {
  color: #999999;
  font-weight: 300;
}
 

 

 

 

 

 

 

 

 

 

 

 

 

 

 

 

 

 
@media(max-width: 991px) {
  .blog-post-card1-image1 {
    height: 350px;
  }
  .blog-post-card1-container3 {
    background-size: cover;
    background-image: url("/logoblue.svg");
  }
}
 
@media(max-width: 479px) {
  .blog-post-card1-container3 {
    background-size: cover;
    background-image: url("/logoblue.svg");
  }
}
</style>
